'use client';

import type { QuantitySelectionAtomizedProps } from '@packages/modules/src/QuantitySelectionAtomized/QuantitySelectionAtomized.client';
import { QuantitySelectionAtomized } from '@packages/modules/src/QuantitySelectionAtomized/QuantitySelectionAtomized.client';
import type { HTMLAttributes } from 'react';

export type QuantitySelectionProps = HTMLAttributes<HTMLDivElement> & {
  quantitySelectionProps?: QuantitySelectionAtomizedProps['quantitySelectionProps'];
};

export const QuantitySelection = ({ quantitySelectionProps, ...props }: QuantitySelectionProps) => (
  <div {...props}>
    <QuantitySelectionAtomized
      quantitySelectionProps={quantitySelectionProps}
      hideLabel={false}
      className="my-1.5"
    />
  </div>
);
